const REGISTER_HTML_ELEMENTS = 'REGISTER_HTML_ELEMENTS'
export function registerHTMLElements(elements) {
  return {
    elements,
    type: REGISTER_HTML_ELEMENTS,
  }
}

const RECEIVE_ORDER_UPDATE = 'RECEIVE_ORDER_UPDATE'
export function receiveOrderUpdate(order) {
  return {
    order,
    type: RECEIVE_ORDER_UPDATE,
  }
}

export default {
  RECEIVE_ORDER_UPDATE,
  REGISTER_HTML_ELEMENTS,
}
